import styled from '@emotion/styled';

import { maxWidthAndCenter, h2, button } from '@styles';

const NewsPreviewContainer = styled.div`
  padding: 4rem 0;
  background: var(--blue);
  text-align: center;

  .news_preview__heading {
    ${h2}
    padding: 0 0 2rem;
    color: var(--orange);
  }

  .news_preview__grid {
    ${maxWidthAndCenter}
    padding: 0 0 3rem;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-column-gap: 2rem;
    grid-row-gap: 2rem;
  }

  .news_preview__item {
    border: 1px solid darkgray;
    padding: 1.25rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: white;
    text-align: left;

    h3 {
      font-weight: 900;
      text-transform: uppercase;
      padding: 0 0 1rem;
    }

    hr {
      margin: 0 0 0 0;
      border-top: 6px solid var(--orange);
      border-bottom: 0px solid transparent;
      max-width: 50%;
    }

    p {
      padding: 1rem 0 1rem;
      line-height: 1.3;
    }

    a {
      margin: 0;
      display: inline-block;
      text-decoration: none;
      color: var(--orange);
      text-transform: uppercase;
      font-weight: 700;

      &:visited {
        color: var(--orange);
      }

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .news_preview__read_more {
    ${button('orange')}
  }

  @media screen and (max-width: 1470px) {
    padding: 4rem 2rem;
  }

  @media screen and (max-width: 1152px) {
    padding: 4rem 0;

    .news_preview__heading {
      padding: 0 2rem 2rem;
    }

    .news_preview__grid {
      padding: 0 2rem 3rem;
      overflow-x: scroll;
    }

    .news_preview__item {
      min-width: 19rem;
    }

    .news_preview__read_more {
      width: calc(100% - 4rem);
      margin: 0 2rem;
    }

    &.news_preview--custom-items {
      .news_preview__grid {
        overflow-x: initial;
        grid-template-columns: 1fr 1fr;
      }
    }
  }

  @media screen and (max-width: 760px) {
    &.news_preview--custom-items {
      .news_preview__grid {
        grid-template-columns: 1fr;
      }
    }
  }
`;

export { NewsPreviewContainer };
